// src/AudioSpectrum/effects/waveform.js

export const drawWaveform = (ctx, timeDomainData, width, height) => {
  ctx.clearRect(0, 0, width, height);
  
  ctx.strokeStyle = '#4CAF50';
  ctx.lineWidth = 2;
  ctx.beginPath();
  
  const sliceWidth = width / timeDomainData.length;
  let x = 0;
  
  for (let i = 0; i < timeDomainData.length; i++) {
    const v = timeDomainData[i] / 128.0;
    const y = v * height / 2;
    
    if (i === 0) {
      ctx.moveTo(x, y);
    } else {
      ctx.lineTo(x, y);
    }
    
    x += sliceWidth;
  }
  
  ctx.stroke();
};